<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="项目基本信息" name="1">
      <info-item
        :title="['项目名称', '项目编码', '父级项目']"
        :data="[detail.projectBaseInfo.name, detail.projectBaseInfo.number, '--']"
      ></info-item>
      <info-item
        :title="['最小预算单元', '产品线', '产品线编码']"
        :data="[
          detail.projectBaseInfo.settlementUnitName,
          detail.projectBaseInfo.productName,
          detail.projectBaseInfo.productCode,
        ]"
      ></info-item>
      <info-item
        :title="['所属区域', '区域编码', '项目标签']"
        :data="[
          detail.projectBaseInfo.regionName,
          detail.projectBaseInfo.regionCode,
          detail.projectBaseInfo.tags,
        ]"
      ></info-item>
      <info-item
        :title="['项目负责人', '项目申请人', '项目类型']"
        :data="[
          detail.projectBaseInfo.personChargeName,
          detail.projectBaseInfo.applicantName,
          detail.projectBaseInfo.projectTypeName,
        ]"
      ></info-item>
      <info-item
        :title="['项目状态', '项目类别', '']"
        :data="[detail.projectBaseInfo.statusName, detail.projectBaseInfo.category, '']"
      ></info-item>
    </el-collapse-item>
    <el-collapse-item title="项目预算" name="2">
      <info-item
        :title="['成本费用(元)', '预计收入(元)', '资金回收周期']"
        :data="[
          detail.projectBudgetInfo.costExpense,
          detail.projectBudgetInfo.estimatedIncome,
          detail.projectBudgetInfo.recoveryCycle,
        ]"
      ></info-item>
      <info-item
        :title="['毛利(元)', '毛利率(%)', '结算部门']"
        :data="[
          detail.projectBudgetInfo.grossprofit,
          detail.projectBudgetInfo.grossMargin,
          detail.projectBudgetInfo.settlementName,
        ]"
      ></info-item>
      <info-item
        :title="['净利(元)', '净利率(%)', '']"
        :data="[
          detail.projectBudgetInfo.netProfit,
          detail.projectBudgetInfo.netMargin,
          '--',
        ]"
      ></info-item>
      <info-item
        :title="['微医云支持预算费用(元)']"
        :data="[detail.projectBudgetInfo.cloudBudgetExpenses]"
      ></info-item>
      <info-item
        :title="['基建装修预算费用(元)']"
        :data="[detail.projectBudgetInfo.infrastructureBudgetExpenses]"
      ></info-item>
      <info-item
        :title="['采购申请预算费用(元)']"
        :data="[detail.projectBudgetInfo.purchaseBudgetExpenses]"
      ></info-item>
    </el-collapse-item>
    <el-collapse-item title="项目OA流程信息" name="3">
      <info-item
        :title="['项目负责人工号', '项目负责人邮箱', '项目负责部门']"
        :data="[
          detail.projectOaProcessInfo.personChargeNo,
          detail.projectOaProcessInfo.personChargeMail,
          detail.projectOaProcessInfo.personChargeDept,
        ]"
      ></info-item>
      <info-item
        :title="['项目申请日期', '项目预计完成日期', '项目申请人工号']"
        :data="[
          detail.projectOaProcessInfo.applyDate,
          detail.projectOaProcessInfo.expectedCompleteDate,
          detail.projectOaProcessInfo.applicantNo,
        ]"
      ></info-item>
      <info-item
        :title="['项目申请人部门', '流程状态', '当前环节']"
        :data="[
          detail.projectOaProcessInfo.applicantDept,
          detail.projectOaProcessInfo.processStatus,
          detail.projectOaProcessInfo.processNode,
        ]"
      ></info-item>
      <info-item
        :title="['流程归档时间']"
        :data="[detail.projectOaProcessInfo.archiveDate]"
      ></info-item>
      <info-item
        :title="['项目内容简介']"
        :data="[detail.projectOaProcessInfo.description]"
      ></info-item>
    </el-collapse-item>
    <el-collapse-item title="项目KPI指标" name="4">
      <info-item
        :title="['项目KPI指标']"
        :data="[detail.projectKpiInfo.kpiDescription]"
      ></info-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InfoItem from "@/components/base/detail-info-item.vue";

export default {
  props: {
    detail: Object,
  },
  components: {
    InfoItem,
  },
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
    };
  },
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.panel-item {
  padding: 0 10px;
  label {
    width: 150px;
    display: inline-block;
    color: @color--info;
  }
  &:last-child {
    .el-col {
      border: none;
    }
  }
}
</style>
